import React from 'react';
import { twMerge } from 'tailwind-merge';

const Container = ({ children, className }) => (
  <div className={twMerge('flex flex-col gap-3 md:gap-8 bg-white p-3 sm:p-4 md:p-6 lg:p-10 border', className)}>
    {children}
  </div>
);

export default Container;
